import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Users, Music, Target, MoreHorizontal, Sparkles } from 'lucide-react';

const tabs = [
  { to: '/', label: 'Dashboard', Icon: Home, exact: true },
  { to: '/contacts', label: 'Contacts', Icon: Users },
  { to: '/artists', label: 'Artists', Icon: Music },
  { to: '/campaigns', label: 'Campaigns', Icon: Target },
  { to: '/meta/alignment', label: 'Alignment', Icon: Sparkles },
  { to: '/settings', label: 'More', Icon: MoreHorizontal },
];

export const BottomTabs: React.FC = () => {
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass e1 bg-white/80 dark:bg-gray-900/80 border-t border-gray-200/60 dark:border-gray-800/60 pb-[env(safe-area-inset-bottom)]"
      aria-label="Primary"
    >
      <ul className="grid grid-cols-6">
        {tabs.map(({ to, label, Icon, exact }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={Boolean(exact)}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2 text-xs font-medium transition-colors ${
                  isActive
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
                }`
              }
              aria-label={label}
            >
              {({ isActive }) => (
                <>
                  <Icon className={`h-5 w-5 mb-0.5 ${isActive ? 'text-blue-500 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`} />
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomTabs;
